import {
    pushToKlaviyo,
    KlaviyoAddedToCartProperties,
    KlaviyoIdentifyProperties,
    KlaviyoViewedProductProperties,
} from 'src/components/Scripts/Klaviyo';
import { createDebug } from 'src/util/debug';
import { getBrowserCookies, isIrishUserCookieValue } from 'src/util/cookies';

const debug = createDebug('klaviyo');

export const getStoreName = (): string => {
    const isIrishUser = isIrishUserCookieValue(getBrowserCookies().get('isIrishUser', { doNotParse: true }));
    return isIrishUser ? 'IE' : 'GB';
};

export const getCurrencyCode = (fallback?: string): string | undefined => {
    if (fallback) return fallback;

    if (typeof window !== 'undefined') {
        const currencyParam = new URLSearchParams(window.location.search).get('cur')?.toUpperCase();
        if (currencyParam) return currencyParam;
    }

    const isIrishUser = isIrishUserCookieValue(getBrowserCookies().get('isIrishUser', { doNotParse: true }));
    return isIrishUser ? 'EUR' : 'GBP';
};

export function ensureKlaviyoIdentified(): void {
    debug('Anonymous tracking - letting Klaviyo handle via native cookies');
}

export function trackViewedProduct(properties: KlaviyoViewedProductProperties): void {
    debug('Tracking Viewed Product', properties);
    pushToKlaviyo(['track', 'Viewed Product', properties]);
}

export function trackAddedToCart(properties: KlaviyoAddedToCartProperties): void {
    debug('Tracking Added to Cart', properties);
    pushToKlaviyo(['track', 'Added to Cart', properties]);
}

export function identifyUser(properties: KlaviyoIdentifyProperties): void {
    debug('Identifying user', properties);
    pushToKlaviyo(['identify', properties]);
}
